export default __webpack_public_path__ + "static/media/imperfect-foods.b14d8e3f.svg";